export const ArrowRightIcon = () => {
  return (
    <svg
      width='31'
      height='26'
      viewBox='0 0 31 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.5303 0.46967C18.2374 0.176776 17.7626 0.176776 17.4697 0.46967C17.1768 0.762563 17.1768 1.23744 17.4697 1.53033L28.1893 12.25H1C0.585786 12.25 0.25 12.5858 0.25 13C0.25 13.4142 0.585786 13.75 1 13.75H28.1893L17.4697 24.4697C17.1768 24.7626 17.1768 25.2374 17.4697 25.5303C17.7626 25.8232 18.2374 25.8232 18.5303 25.5303L30.5303 13.5303C30.8232 13.2374 30.8232 12.7626 30.5303 12.4697L18.5303 0.46967Z'
        fill='white'
      />
    </svg>
  );
};
